/**
 * Graph/Chart API functions
 */
import { ENDPOINTS } from './endpoints';
import { getRequestBackendDataV2 } from './core';

export const getGraphData = async (auth, callback, instrument, timeframe, count, source) => {
    await getRequestBackendDataV2(auth, callback, ENDPOINTS.GRAPH.DATA(instrument, timeframe, count, source));
};

